export default __webpack_public_path__ + "static/media/dobri_l.c95d9cb5.jpg";